import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router';
import { toastConfig } from 'utils/toast.config';
import { urlConfig } from 'utils/url-config';

const useDeletePost = () => {
	const queryClient = useQueryClient();

	const navigate = useNavigate();

	const mutation = useMutation(
		(id: string) =>
			fetch(`${urlConfig.API_URL}${urlConfig.api.post.replace(':id', id)}`, {
				method: 'DELETE',
				headers: {
					'Content-Type': 'application/json',
					Authorization: 'Bearer ' + localStorage.getItem('token'),
				},
			}),
		{
			onSuccess: () => {
				queryClient.invalidateQueries('posts');
				toastConfig.post.delete.success();
				navigate(urlConfig.pages.main);
			},
			onError: () => {
				toastConfig.post.delete.error();
			},
		}
	);

	return mutation;
};

export default useDeletePost;
